import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const LocationTab = createComponent('div', {
  className: cx(
    'mb-32 h-auto w-full bg-blue-6 px-16 py-20 sm:p-28',
    'flex flex-col items-start justify-start sm:flex-row sm:justify-between md:justify-center md:gap-48'
  )
});

export const TileWrapper = createComponent('div', {
  className: 'my-8 flex w-full justify-between text-white sm:block sm:w-auto'
});

export const TileTitle = createComponent('div', {
  className: 'tl-label-m'
});

export const AdditionalInfo = createComponent('div', {
  className: 'w-[250px] sm:w-auto'
});
